// src/components/ui/Avatar.tsx

import { User } from "lucide-react";

interface AvatarProps {
  size?: "sm" | "md" | "lg";
}

export function Avatar({ size = "md" }: AvatarProps) {
  const sizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  };

  return (
    <div
      className={`bg-gray-200 rounded-full flex items-center justify-center ${sizes[size]}`}
    >
      <User className={`text-gray-500 ${iconSizes[size]}`} />
    </div>
  );
}
